










































import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { MrfiktivPartnerViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ISharedContent } from "@/models/shared-content.entity";
import { $t } from "@/lib/utility/t";
import { IShortUser } from "@/models/short-user.entity";
import { IReport } from "@/models/report.entity";

@Component({
  components: {}
})
export default class SharedContentAccessDescription extends Vue {
  @Prop()
  sharedContent!: ISharedContent;

  @Prop()
  user!: IShortUser;

  @Prop()
  partner!: MrfiktivPartnerViewModelGen;

  @Prop()
  report?: IReport;

  get validByText() {
    if (this.sharedContent.validBy) {
      return $t("views.PartnerSharedReport.validBy", { date: simpleDoubleDigitDate(this.sharedContent.validBy) });
    }
    return $t("views.PartnerSharedReport.validIndefinitely");
  }

  get contactMailto() {
    const to = this.partner?.settings?.contact.email;
    const cc = this.partner.settings?.inboxes.find(i => i.isActive && i.source === "email")?.identifier;

    let stringBuilder = `mailto:${to}?`;
    if (cc) {
      const [partner, domain] = cc.split("@");

      let mail = `${partner}`;
      if (this.report) {
        mail += `+${this.report?.id}`;
      }
      mail += `@${domain}`;

      stringBuilder += `cc=${mail}`;
    }

    if (this.report) {
      const subject = this.report?.externalId ? this.report?.externalId : `[${this.report?.claimNumber}] `;

      if (cc) {
        stringBuilder += "&";
      }

      stringBuilder += `subject=${subject}`;
    }

    return stringBuilder;
  }
}
